import { withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";

const CloseButton = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

export default CloseButton;
